interface RepeaterRoot extends HTMLElement {
    _cmsJsonRepeaterMounted?: boolean;
}

function pretty(value: unknown): string {
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value, null, 2);
    } catch {
        return "";
    }
}

function parseInitial(raw: string): string[] {
    if (raw.trim() === "") return [];
    try {
        const decoded = JSON.parse(raw) as unknown;
        if (Array.isArray(decoded)) return decoded.map(pretty);
        return [pretty(decoded)];
    } catch {
        return [raw];
    }
}

function sync(root: RepeaterRoot): void {
    const hidden = root.querySelector<HTMLTextAreaElement>("[data-cms-json-repeater-value]");
    if (!hidden) return;

    const rows = Array.from(root.querySelectorAll<HTMLTextAreaElement>("[data-cms-json-repeater-item]"));
    const values: unknown[] = [];
    for (const row of rows) {
        const raw = row.value.trim();
        if (raw === "") continue;
        try {
            values.push(JSON.parse(raw) as unknown);
        } catch {
            values.push(raw);
        }
    }
    hidden.value = JSON.stringify(values, null, 2);
    hidden.dispatchEvent(new Event("input", { bubbles: true }));
}

function addRow(root: RepeaterRoot, value = ""): void {
    const list = root.querySelector<HTMLElement>("[data-cms-json-repeater-list]");
    if (!list) return;

    const row = document.createElement("div");
    row.className = "admin-cms-json-repeater__row";
    row.innerHTML = `
        <textarea class="admin-form__input admin-form__textarea admin-cms-json-repeater__input" rows="4" data-cms-json-repeater-item></textarea>
        <button type="button" class="admin-btn admin-btn--secondary admin-btn--sm admin-cms-json-repeater__remove" data-cms-json-repeater-remove aria-label="Remove item">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    `;
    const input = row.querySelector<HTMLTextAreaElement>("[data-cms-json-repeater-item]");
    if (input) input.value = value;
    list.appendChild(row);
    sync(root);
}

function mount(root: RepeaterRoot): void {
    if (root._cmsJsonRepeaterMounted) return;
    root._cmsJsonRepeaterMounted = true;

    const hidden = root.querySelector<HTMLTextAreaElement>("[data-cms-json-repeater-value]");
    const initial = parseInitial(hidden?.value ?? "");
    if (initial.length === 0) addRow(root, "");
    initial.forEach((value) => addRow(root, value));

    root.addEventListener("click", (event) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest("[data-cms-json-repeater-add]")) {
            event.preventDefault();
            addRow(root, "{}");
        }
        const remove = target?.closest("[data-cms-json-repeater-remove]");
        if (remove) {
            event.preventDefault();
            remove.closest(".admin-cms-json-repeater__row")?.remove();
            sync(root);
        }
    });
    root.addEventListener("input", (event) => {
        const target = event.target as HTMLElement | null;
        if (target?.matches("[data-cms-json-repeater-item]")) sync(root);
    });
}

export function initCmsJsonRepeaters(scope: Document | HTMLElement = document): void {
    scope.querySelectorAll<RepeaterRoot>("[data-cms-json-repeater]").forEach(mount);
}
